import startishardLogo from './images/startishard.png';
import lupaLogo from './images/lupa.png';
import instinktLogo from './images/instinkt.png';
import roklenLogo from './images/roklen24.png';
import marketingSalesMediaLogo from './images/marketing-sales-media.png';
import shoptetLogo from './images/shoptet.png';
import czechCrunchLogo from './images/czechcrunch.png';
import jenProZenyLogo from './images/jen-pro-zeny.png';
import startupJobsLogo from './images/startup-jobs.png';
import marketingJournalLogo from './images/m-journal.png';
import eshopRychleLogo from './images/eshop-rychle.png';
import finlordLogo from './images/finlord.png';
import technetLogo from './images/technet.gif';
import podnikatelLogo from './images/podnikatel.png';
import investujemeLogo from './images/investujeme.png';
import erpLogo from './images/erp.png';
import applikaceLogo from './images/applikace.png';
import feedITLogo from './images/feedit.gif';
import startupistiLogo from './images/startupisti.png';
import e15logo from './images/e15.png';
import androidAplikaceLogo from './images/android_aplikace.png';
import mediarLogo from './images/mediar.png';
import forbesLogo from './images/forbes.png';
import streamLogo from './images/stream.png';
import petraLovelyHairLogo from './images/lovely.png';
import CTLogo from './images/ct.png';
import beautyLifeLogo from './images/beauty-life.png';
import CIANewsLogo from './images/cianews.png';
import ekonomickyMagazinLogo from './images/ekonomicky-magazin.png';
import lidoveNoviny from './images/lidove-noviny.svg';
import lidovky from './images/lidovky.png';
import esquire from './images/esquire.png';
import idnesLogo from './images/idnes-logo.jpg';
import foxentry from './images/foxentry.png';
import ihned from './images/ihned.jpg';
import jobs from './images/jobs-cz.png';
import cosmopolitan from './images/cosmopolitan.png';
import harpersbazaar from './images/harpers_bazaar.png';
import retailnews from './images/retailnews.png';
import modio from './images/modio.png';
import superpotlac from './images/superpotlac.png';
import {
  TYPE_INTERNET,
  TYPE_PARTNERS,
  TYPE_PRINT,
  TYPE_BLOG,
} from './constants';

export interface Article {
  logo: string;
  id: number;
  type: string;
  text: string;
  link: string;
  journal: string;
  video?: string;
  youtube?: string;
}

export default [
  {
    logo: superpotlac,
    id: 55,
    type: TYPE_BLOG,
    text: 'V květnu 2021, internetový obchod s módním oblečením a doplňky superpotlac.sk, integroval službu SizeID, aby usnadnil výběr správné velikosti svým zákazníkům. Po zavedení SizeID se projevil pozitivní vliv na konverzní poměr. U návštěvníků, kteří využili při nakupování SizeID, se ukázal až 40% nárůst konverzního poměru oproti návštěvníkům, kteří SizeID nevyužili.',
    link: '/static/files/CaseStudy_SizeIDxSuperpotlac.pdf',
    journal: 'SizeID & Superpotlac.sk, květen 2021',
  },
  {
    logo: modio,
    id: 54,
    type: TYPE_INTERNET,
    text: 'Líbí se vám nějaký kousek? Vyplňte základní údaje o vaší postavě a obchod vám u produktu doporučí tu nejvhodnější velikost. Pokud jste registrovaný uživatel, můžete si informace o sobě i o vašich blízkých uložit na profilu a další nákupy budou jednodušší.',
    link: 'https://www.modio.cz/amp/i/recenze-zoot-zkusenosti-s-nakupem-a-vracenim-zbozi',
    journal: 'modio.cz, 9. července 2021',
  },
  {
    logo: retailnews,
    id: 53,
    type: TYPE_INTERNET,
    text: 'Chceme zákazníkům co nejvíce usnadnit nákup a hlavně se pokusit předejít nutnosti řešit výměnu za jinou velikost nebo samotnému vrácení. Snižování vratek je cesta jak k udržitelnosti našeho byznysu, tak k udržitelnosti vzhledem k naší planetě. Právě správný výběr velikosti v tom hraje důležitou roli.',
    link: 'https://retailnews.cz/aktualne/zoot-nasazuje-nejmodernejsi-technologie-pro-lepsi-orientaci-ve-velikostech/',
    journal: 'retailnews.cz, 9. června 2021',
  },
  {
    logo: jobs,
    id: 52,
    type: TYPE_INTERNET,
    text: 'Firemní kultura je něco, díky čemu se můžete v zaměstnání cítit jako doma, mezi „svými“. Pokud vám sedne, bude pro vás jednodušší řešit s kolegy každodenní agendu i dlouhodobější projekty, ztotožnit se s cíli i hodnotami společnosti. Jiná kultura bude panovat v mezinárodní firmě, jiná v lokální společnosti a jiná ve start-upu. Na čem stojí firemní kultura a jak se projevuje při náboru, jsme se zeptali ve třech různých společnostech.',
    link: 'https://www.jobs.cz/poradna/tri-spolecnosti-a-tri-ruzne-firemni-kultury-jak-se-projevuji-a-proc-jim-venovat-pri-hledani-prace-pozornost/',
    journal: 'jobs.cz, 22. dubna 2021',
  },
  {
    logo: foxentry,
    id: 51,
    type: TYPE_INTERNET,
    text: 'Na straně e-shopu je integrováno SizeID tlačítko „Doporučit velikost" (po kliknutí na tlačítko např. u bot vás vyzve k zadání délky chodidla v cm, po potvrzení vám nástroj doporučí velikost/i), nebo, pokud e-shop aktivně nespolupracuje se SizeID, si necháte doporučit velikost ve webovém rozhraní nebo appce SizeID. Takto můžete se SizeID chodit nakupovat i do kamenných obchodů a ušetříte si zkoušení zbytečně velkého množství nepadnoucích kousků v kabince.',
    link: 'https://foxentry.cz/3-prakticke-funkce-pro-vas-e-shop-kterymi-nadchnete-zakazniky-inspirujte-se/',
    journal: 'Foxentry.cz, 14. března 2019',
  },
  {
    logo: ihned,
    id: 50,
    type: TYPE_INTERNET,
    text: 'Hned krátce po založení Zásilkovny jsem investovala do IT firmy MYPS, která vyvíjí webové aplikace. Následně jsem v projektu SizeID koupila nejprve 11 procent, pak podíl navýšila na 16 procent. SizeID je taková zajímavá aplikace, kde si přes mobil můžete koupit oblečení podle vašich uložených propozic. Snižuje to vratky obchodníků. To je totiž velký fenomén v oboru nákupu módy. Celý ten obor roste krásně, pojí se s tím ale vratky ve výši 20 až 50 procent.',
    link: 'https://archiv.ihned.cz/c1-66448790-i-simona-kijonkova',
    journal: 'iHNed.cz, 28. ledna 2019',
  },
  {
    logo: idnesLogo,
    id: 49,
    type: TYPE_INTERNET,
    text: 'Technologie mění online nákup oblečení. Obchody specializující se na prodej na internetu stále usilovněji vymýšlejí, jak překonat základní nevýhodu proti kamenným prodejnám – to, že si zákazník nemůže zboží vyzkoušet.',
    link: 'https://ekonomika.idnes.cz/e-shop-moda-online-nakup-internet-obleceni-fis-/ekonomika.aspx?c=A181015_183101_ekonomika_mato',
    journal: 'iDNES.cz, 16. října 2018',
  },
  {
    logo: e15logo,
    id: 48,
    type: TYPE_INTERNET,
    text: 'Kolem byznysu s prodejem oblečení přes internet se začaly objevovat start-upy, které internetovým obchodníkům nabízejí nástroje k usnadnění cesty k zákazníkům. Například společnost SizeID vyvinula technologii, která kupujícímu doporučí nejsprávnější velikost oblečení a obuvi.',
    link: 'https://www.e15.cz/byznys/obchod-a-sluzby/ceske-e-shopy-s-modou-se-placaji-ve-ztratach-1351983',
    journal: 'E15.cz, 5. října 2018',
  },
  {
    logo: esquire,
    id: 47,
    type: TYPE_PRINT,
    text: 'Když se mě někdo ptá, co dělám, občas z legrace říkám, že se snažím zachraňovat svět. Je to nadsázka, ale vlastně si myslím, že každý by se měl snažit zachránit svět nebo ho dělat lepším.',
    link: '/static/files/esquire_10-2018.pdf',
    journal: 'Esquire, říjen 2018; str. 112-114',
  },
  {
    logo: lidovky,
    id: 46,
    type: TYPE_INTERNET,
    text: 'Usnadnit orientaci se snaží i český startup SizeID, aplikace, do které se při registraci zadají míry a ona už sama porovná velikosti v různých obchodech nebo na e-shopu. V současné době má v databázi na 635 značek.',
    link: 'https://www.lidovky.cz/relax/moda/velikost-s-m-l-nebo-xl-proc-nam-nesedi-obleceni.A180826_153750_moda_ele',
    journal: 'LIDOVKY.cz, 27. srpna 2018',
  },
  {
    logo: lidoveNoviny,
    id: 45,
    type: TYPE_PRINT,
    text: 'Vybrat si správnou velikost oblečení pro sebe nebo pro děti připomíná detektivní pátrání. Dávno už neplatí, že člověk může jednoduše sáhnout po tom, co kupoval obvykle. Číslo na visačce v různých obchodech totiž může ukazovat i tři rozdílné hodnoty. Není divu, že spousta lidí ani neví, jakou má velikost.',
    link: '/static/files/lidove_noviny_08-25-2018.pdf',
    journal: 'Lidové noviny - Praha, 25. srpna 2018; str. 27-28',
  },
  {
    logo: ekonomickyMagazinLogo,
    id: 44,
    type: TYPE_INTERNET,
    text: 'SizeID slaví další úspěchy na poli eCommerce. Revolučnímu řešení pro snadný výběr velikosti se podařilo proniknout do další platformy. FastCentrik, poskytovatel kompletního eshopového řešení pro segment menších firem a živnostníků, rozšířil své portfólio přídavných pluginů o tlačítko „Doporučit velikost". SizeID tak boří další milník na cestě v nakupování oblečení a obuvi na internetu.',
    link: 'https://www.ekonomickymagazin.cz/2018/06/nakup-obleceni-online-je-o-krok-dal-o-inovovane-sizeid/',
    journal: 'Ekonomický magazín, 26. června 2018',
  },
  {
    logo: roklenLogo,
    id: 43,
    type: TYPE_INTERNET,
    text: 'Integrací do platformy FastCentrik úspěchy služby nekončí. Po měsících vývoje dochází k vylepšení funkcí. SizeID, zatím v beta verzi, přináší další možnost snadného doporučení velikosti, a to bez nutnosti zadávání měr. Další novinkou je redesign uživatelského prostředí služby, přívětivější jak pro spotřebitele, tak on-line prodejce. Mezi novými partnery můžeme uvítat například Hanibal, jednoho z nejlepších specialistů na outdoorové oblečení a vybavení, nebo třeba českou sportovní značku Loap.',
    link: 'https://roklen24.cz/a/SPRnC/znate-z-fundliftu-inovovane-sizeid-posouva-nakup-obleceni-o-krok-dal',
    journal: 'Roklen24.cz, 25. června 2018',
  },
  {
    logo: cosmopolitan,
    id: 42,
    type: TYPE_PRINT,
    text: 'Do startupu se určitě vyplatí jít. Mě osobně na téhle práci baví hlavně to, že můžu kreativně myslet, přinášet nápady, podporovat rozvoj a expanzi naší služby, podílet se na plánování a strategiích a pomáhat budovat značku SizeID. Jsem tak součástí unikátního a zajímavého projektu, u kterého nehrozí monotónnost.',
    journal: 'Cosmopolitan, červen 2018; str. 144-145',
    link: '/static/files/cosmopolitan_06-2018.pdf',
  },
  {
    logo: harpersbazaar,
    id: 41,
    type: TYPE_PRINT,
    text: 'Nakupovat oblečení a boty přes internet je výrazně pohodlnější a rychlejší než v kamenném obchodě - vyhnete se frontám i nekonečnému převlékání se v kabince. Zvolit si správnou velikost ale může být problém: někdy je to jen S, M a L, jindy je značení číselné, ale u každého výrobce sedí šaty, kalhoty nebo košile jinak.',
    link: '/static/files/online_nakupy_12-2017.pdf',
    journal: "Harper's Bazaar, prosinec 2017; str.12-13",
  },
  {
    logo: startishardLogo,
    id: 40,
    type: TYPE_INTERNET,
    text: 'Když vybíráte oblečení, vždy se musíte rozhodnout mezi tím, jaký chcete střih, barvu a materiál. Vždy ale chcete jednu věc a to, aby Vám daný kus seděl přesně podle Vašich představ. Český startup SizeID vymyslel způsob, jak Vám ulehčit rozhodování a jak „trefit" tu správnou velikost!',
    link: 'http://startishard.cz/sizeid-startup-ktery-zjednodusil-vyber-vhodne-velikosti/',
    journal: 'Startishard, 15. prosince 2017',
  },
  {
    logo: marketingSalesMediaLogo,
    id: 39,
    type: TYPE_PRINT,
    text: 'E-shopy, které prodávají módu a zároveň fungují na platformách Shoptet a Eshop-rychle, navázaly spolupráci s technologickým řešením Size ID. Start-up připravil i modul pro další e-commerce platformu – PrestaShop.',
    link: '/static/files/marketing-sales-media.pdf',
    journal: 'MarketingSalesMedia; str. 5, 19. června 2017',
  },
  {
    logo: lupaLogo,
    id: 38,
    type: TYPE_INTERNET,
    text: 'SizeID loví e-shopové platformy. Míry už měří i v obchodech Shoptetu nebo Eshop-rychle.',
    link: 'https://www.lupa.cz/aktuality/sizeid-lovi-e-shopove-platformy-miry-uz-meri-i-v-obchodech-shoptetu/',
    journal: 'Lupa.cz, 13. června 2017',
  },
  {
    logo: startupJobsLogo,
    id: 37,
    type: TYPE_INTERNET,
    text: 'SizeID se může pochlubit poměrně neotřelým business modelem, který propojuje B2B a B2C segment.',
    link: 'https://www.startupjobs.cz/en/blog/sizeid-setrime-cas-obchodum-i-zakaznikum',
    journal: 'StartupJobs, 10. března 2017',
  },
  {
    logo: eshopRychleLogo,
    id: 36,
    type: TYPE_PARTNERS,
    text: 'Máte nebo plánujete e-shop s oblečením? Pak vás bude zajímat nová integrace služby SizeID na Eshop-rychle. Díky SizeID si u vás zákazníci snáze vyberou oblečení a vy tak získáte velmi zajímavou konkurenční výhodu.',
    link: 'http://blog.eshop-rychle.cz/integrace-sizeid-eshoprychle/',
    journal: 'Eshop-rychle.cz, 25. května 2017',
  },
  {
    logo: marketingSalesMediaLogo,
    id: 35,
    type: TYPE_PRINT,
    text: 'Vratky jako noční můru e-shopů s oblečením se snaží minimalizovat český start-up SizeID. Spolupracuje s e-shopy, zároveň ale slouží skrz aplikaci i jednotlivcům díky široké databázi značek.',
    link: '/static/files/18_2017_MSM.pdf',
    journal: 'MarketingSalesMedia, 24. dubna 2017',
  },
  {
    logo: czechCrunchLogo,
    id: 34,
    type: TYPE_INTERNET,
    text: 'Tvůrci oznamují další důležitý milník, který tentokrát pomůže především s rozšířením k větší skupině zákazníků, a to konkrétně integraci do eshopových platforem Shoptet a Eshop-rychle.',
    link: 'http://www.czechcrunch.cz/2017/06/ceska-fashion-platforma-sizeid-doporucujici-vhodnou-velikost-obleceni-nyni-podporuje-eshopy-od-shoptet/',
    journal: 'CzechCrunch, 13. června 2017',
  },
  {
    logo: roklenLogo,
    id: 33,
    type: TYPE_INTERNET,
    text: 'Přímé napojení na Shoptet a další e-shopová řešení je pro nás klíčová cesta, jak službu rozšířit do více e-shopů a dostat ji k více spotřebitelům.',
    link: 'http://roklen24.cz/a/w2sg6/sizeid-se-rychle-rozsiruje-s-podporou-prisel-shoptet',
    journal: 'Roklen24.cz, 13. června 2017',
  },
  {
    logo: instinktLogo,
    id: 32,
    type: TYPE_PRINT,
    text: 'Velikost? Sedí... Obavy z nákupu v e-shopech jsou minulostí – především obavy z nesprávné velikosti oblečení a bot.',
    link: '/static/files/instinkt_26-2017.pdf',
    journal: 'Instinkt, číslo 26/2017; str. 9, 22. června 2017',
  },
  {
    logo: lupaLogo,
    id: 31,
    type: TYPE_INTERNET,
    text: 'Startup, který řeší problémy prvního světa, se zabydluje v e-shopových systémech.',
    link: 'https://www.lupa.cz/clanky/esopak-bitcoiny-v-alze-utraci-hlavne-cizinci-ikea-zacala-prodavat-na-amazonu/',
    journal: 'Lupa.cz, 17. června 2017',
  },
  {
    logo: shoptetLogo,
    id: 30,
    type: TYPE_PARTNERS,
    text: 'Máte pocit, že vaši zákazníci mnohdy nedokončí nákup, protože neví, jakou velikost si vybrat? Nejste daleko od pravdy. Dost lidí se pořád bojí nakupovat oblečení online, protože nevědí, jak pracovat s velikostní tabulkou, nebo jim celý proces přijde zdlouhavý a nepohodlný. Vyřešte to novým nástrojem SizeID.',
    link: 'https://blog.shoptet.cz/sizeid-uz-vam-neutece-zadny-zakaznik-kvuli-velikosti-obleceni/',
    journal: 'Shoptet.cz, 31. května 2017',
  },
  {
    logo: technetLogo,
    id: 29,
    type: TYPE_INTERNET,
    text: 'Chcete si přes internet koupit novou bundu. Ale jak se trefit do správné velikosti? Pomůže služba SizeID.com',
    link: 'http://technet.idnes.cz/velikost-obleceni-na-webu-0ya-/sw_internet.aspx?c=A161206_113231_sw_internet_dvr',
    journal: 'Technet.cz, 19. prosince 2016',
  },
  {
    logo: jenProZenyLogo,
    id: 28,
    type: TYPE_INTERNET,
    text: 'Už se nemusíte bát, že vámi vybrané šatičky vám nepadnou jako ulité. Existuje služba, která vám se správnou velikostí pomůže.',
    link: 'http://www.jenprozeny.cz/krasa-moda/50191-nebojte-nakupovat-online',
    journal: 'JenProŽeny.cz, 5. prosince 2016',
  },
  {
    logo: marketingJournalLogo,
    id: 27,
    type: TYPE_INTERNET,
    text: 'SizeID vám jednoduše doporučí vhodnou velikost oblečení ještě předtím, než si ho budete moci skutečně vyzkoušet.',
    link: 'http://www.m-journal.cz/cs/aktuality/sizeid-zkousi-investicni-crowdfunding-kampani-na-portalu-fundlift--vybralo-uz-temer-2-miliony__s288x12552.html',
    journal: 'Marketing Journal, 5. prosince 2016',
  },
  {
    logo: roklenLogo,
    id: 26,
    type: TYPE_INTERNET,
    text: 'Projekt SizeID, se stal vítězem Impact Hub MashUpu. Minulý týden v Praze porazil v soutěži dalších devět projektů. „Úspěch posílil pocit, že práce na SizeID má smysl a motivuje nás to do další práce,“ říká spoluzakladatel SizeID Adam Bičiště.',
    link: 'http://roklen24.cz/a/iit5D/projekt-sizeid-vyhral-soutez-startupu',
    journal: 'Roklen24.cz, 30. listopadu 2016',
  },
  {
    logo: finlordLogo,
    id: 25,
    type: TYPE_INTERNET,
    text: 'SizeID je rozhodně velmi užitečná služba, zlepšuje nákupní zážitek spotřebitelů a redukuje náklady e-shopům. Představený finanční plán je realizovatelný.',
    link: 'https://finlord.cz/2016/11/fundlift-sizeid-na-velikosti-zalezi/',
    journal: 'Finlord.cz, 10. listopadu 2016',
  },
  {
    logo: investujemeLogo,
    id: 24,
    type: TYPE_INTERNET,
    text: 'Problém výběru správné velikosti oblečení bude minulostí. Globálnímu rozvoji SizeID pomohou prostředky z Fundliftu.',
    link: 'http://www.investujeme.cz/problem-vyberu-spravne-velikosti-obleceni-bude-minulosti-globalnimu-rozvoji-sizeid-pomohou-prostredky-z-fundliftu/',
    journal: 'Investujeme.cz, 4. listopadu 2016',
  },
  {
    logo: roklenLogo,
    id: 23,
    type: TYPE_INTERNET,
    text: 'SizeID vstupuje na Fundlift pro miliony korun výměnou za investici s 10% úrokem. Chce vyrůst v globálního lídra velikostních standardů oblečení.',
    link: 'http://roklen24.cz/a/wWjwr/obavy-o-spravny-vyber-velikosti-obleceni-se-sizeid-budou-minulosti',
    journal: 'Roklen24.cz, 3. listopadu 2016',
    video: 'https://sizeid.com/data/fundlift.mp4',
  },
  {
    logo: podnikatelLogo,
    id: 22,
    type: TYPE_INTERNET,
    text: 'E-shopisté, minimalizujte ztráty z vratek oblečení. Poradíme, jak na to!',
    link: 'http://www.podnikatel.cz/clanky/e-shopiste-minimalizujte-ztraty-z-vratek-obleceni-poradime-jak-na-to/',
    journal: 'Podnikatel.cz, 5. února 2016',
  },
  {
    logo: erpLogo,
    id: 21,
    type: TYPE_INTERNET,
    text: 'Technologický e-commerce startup SizeID spojuje síly s projektem Zásilkovna.cz',
    link: 'http://erp-systemy.cz/zasilkovna-se-stava-strategickym-partnerem-sizeid/',
    journal: 'ERP SYSTÉMY, 25. ledna 2016',
  },
  {
    logo: czechCrunchLogo,
    id: 20,
    type: TYPE_INTERNET,
    text: 'Nakupování oblečení přes internet má stále jedno velké úskalí – často totiž stačí špatně odhadnou velikost a balíček s novými přídavky do vašeho šatníků může rovnou putovat zpět. Přesně takovým situacím předchází SizeID',
    link: 'http://www.czechcrunch.cz/2016/11/cesky-fashion-startup-sizeid-miri-na-fundlift-kde-chce-vybrat-3-miliony-kc/',
    journal: 'CzechCrunch.cz, 3. listopadu 2016',
  },
  {
    logo: lupaLogo,
    id: 19,
    type: TYPE_INTERNET,
    text: 'Simona Kijonková se pustila do rozšiřování své stáje a propojí svou doručovací službu se startupem, který má ulehčit online nakupování oblečení.',
    link: 'http://www.lupa.cz/clanky/majitelka-zasilkovny-kupuje-podil-v-sizeid-startup-ceka-cesta-do-ciziny/',
    journal: 'Lupa.cz, 25. ledna 2016',
  },
  {
    logo: feedITLogo,
    id: 18,
    type: TYPE_INTERNET,
    text: 'Nebojte se oblečení z eshopu! Správnou velikost Vám vybere SizeID',
    link: 'http://www.feedit.cz/wordpress/2016/02/08/nebojte-se-obleceni-z-eshopu-spravnou-velikost-vam-vybere-sizeid/',
    journal: 'FeedIT.cz, 8. února 2016',
  },
  {
    logo: e15logo,
    id: 17,
    type: TYPE_INTERNET,
    text: 'Tuzemský start-up SizeID, který vyvíjí řešení pro snazší nákup módy přes internet, získal nový kapitál od investorky Simony Kijonkové.',
    link: 'http://e-svet.e15.cz/internet/majitelka-zasilkovny-kijonkova-vstupuje-do-sizeid-1265462',
    journal: 'E15.cz, 26. ledna 2016',
  },
  {
    logo: marketingJournalLogo,
    id: 16,
    type: TYPE_INTERNET,
    text: 'Zásilkovna se stává strategickým partnerem SizeID. Synergie těchto projektů přinese online prodejcům unikátní řešení podporující pohodlný a spolehlivý nákup oblečení a módy na internetu.',
    link: 'http://www.m-journal.cz/cs/aktuality/zasilkovna-se-stava-strategickym-partnerem-sizeid__s288x11841.html',
    journal: 'Marketing Journal, 25. ledna 2016',
  },
  {
    logo: mediarLogo,
    id: 15,
    type: TYPE_INTERNET,
    text: 'Zakladatelka logistického projektu Zásilkovna.cz Simona Kijonková se stala novou spolumajitelkou technologického e-commerce startupu SizeID. Pro SizeID znamená spolupráce se Zásilkovnou podporu při chystané expanzi na zahraniční trhy, kde už Zásilkovna působí.',
    link: 'http://www.mediar.cz/kijonkova-ze-zasilkovny-koupila-podil-v-sizeid/',
    journal: 'MÉDIÁŘ, 22. ledna 2016',
  },
  {
    logo: applikaceLogo,
    id: 14,
    type: TYPE_BLOG,
    text: 'Aplikace SizeID vám doporučí správnou velikost, aniž byste museli navštívit obchod.',
    link: 'http://www.applikace.cz/porad-serie-3-dil-14',
    journal: 'Applikace.cz, 5. prosince 2015',
    video: 'https://sizeid.com/data/SizeID-applikace.mp4',
  },
  {
    logo: startupistiLogo,
    id: 13,
    type: TYPE_INTERNET,
    text: 'Svou velikost oblečení si již nespleteš díky aplikaci SizeID',
    link: 'http://www.startupisti.cz/svou-velikost-obleceni-si-jiz-nespletes-diky-aplikaci-sizeid/',
    journal: 'STARTUPISTI.cz, 19. srpna 2015',
  },
  {
    logo: streamLogo,
    id: 12,
    type: TYPE_BLOG,
    text: 'Velkou neznámou při nákupu oblečení přes internet je správná velikost. Jak vybrat tu správnou pomocí SizeID mobilní aplikace, se můžete podívat v pořadu SWAJP.',
    link: 'https://www.stream.cz/swajp/10006001-jak-vyzrat-na-kamenne-obchody',
    journal: 'Stream, SWAJP, 11. června 2015',
    video: 'https://sizeid.com/data/sizeid-swajp-web.mp4',
  },
  {
    logo: czechCrunchLogo,
    id: 11,
    type: TYPE_INTERNET,
    text: 'Český fashion startup SizeID doporučí vhodnou velikost oblečení nebo bot. Může to fungovat?',
    link: 'http://www.czechcrunch.cz/2015/06/startup-sizeid-doporuci-vhodnou-velikost-obleceni-nebo-bot-muze-to-fungovat/',
    journal: 'CzechCrunch, 3. června 2015',
  },
  {
    logo: marketingSalesMediaLogo,
    id: 10,
    type: TYPE_INTERNET,
    text: 'Start-up SizeID, který se letos v březnu představil na konferenci Fashiontech, má prvního klienta z řad on-line obchodů. Službu zařadil e-shop Boardstar.cz.',
    link: 'http://marketingsales.tyden.cz/rubriky/obchod/sluzba-sizeid-zacala-fungovat-v-prvnim-e-shopu-spousti-ji-boardstar-cz_344375.html',
    journal: 'MarketingSalesMedia, 28. května 2015',
  },
  {
    logo: androidAplikaceLogo,
    id: 9,
    type: TYPE_INTERNET,
    text: 'Předně je potřeba pochválit design aplikace, který je fantasticky přehledný a využívá standardních prvků Android 5.0, tudíž vypadá opravdu moderně a stále svěže.',
    link: 'http://androidaplikace.cz/index.php/2015/04/sizeid-konec-zmatkum-ve-velikostech-obleceni/',
    journal: 'AndroidAplikace, 30. dubna 2015',
  },
  {
    logo: lupaLogo,
    id: 8,
    type: TYPE_INTERNET,
    text: 'Češi se už nebojí nakupovat módu na internetu. Teď jde o to, jak trefit velikost, když výrobci používají různé velikostní tabulky.',
    link: 'http://www.lupa.cz/clanky/sizeid-resi-problemy-prvniho-sveta-jak-nakoupit-padnouci-obleceni-na-webu/',
    journal: 'Lupa.cz, 2. dubna 2015',
  },
  {
    logo: marketingJournalLogo,
    id: 7,
    type: TYPE_INTERNET,
    text: 'SizeID proto přichází jako služba, již by měli uvítat zákazníci i e-shopy, pro které představují časté vratky zbytečné náklady a logistické komplikace.',
    link: 'http://www.m-journal.cz/cs/aktuality/mercedes-benz-prague-fashion-weekend--cesky-startup-sizeid-vam-chce-pomoci-vybrat-tu-spravnou-velikost-obleceni-online__s288x11219.html',
    journal: 'Marketing Journal, 24. března 2015',
  },
  {
    logo: czechCrunchLogo,
    id: 6,
    type: TYPE_INTERNET,
    text: 'Pro získání ideální velikosti je nutné zadat značku a typ oblečení, na základě čehož vás poté aplikace provede správným měřením. Jednoduchý princip, ale funkční.',
    link: 'http://www.czechcrunch.cz/2015/03/nova-appka-od-ceskeho-startupu-sizeid-vyresi-vase-problemy-s-oblecenim/',
    journal: 'CzechCrunch, 16. března 2015',
  },
  {
    logo: CTLogo,
    id: 5,
    type: TYPE_BLOG,
    text: 'Nakupování oblečení na internetu by mohla usnadnit nová služba SizeID. Zákazník na webových stránkách zadá své míry a ty se automaticky doplní ke konkrétnímu zboží. Podle odborníků by to mohlo snížit množství vráceného zboží a tím i náklady na jeho převoz.',
    link: 'http://www.ceskatelevize.cz/ivysilani/1097181328-udalosti/215411000100125/obsah/376601-uskali-nakupovani-pres-internet',
    journal: 'Česká televize, Události, 25. ledna 2015',
    video: 'https://sizeid.com/data/SizeID-reportazCT-web.mp4',
  },
  {
    logo: forbesLogo,
    id: 4,
    type: TYPE_INTERNET,
    text: 'Kouzlo SizeID spočívá v tom, že aplikace obsahuje stále se rozšiřující databázi velikostních tabulek různých značek a dokáže je standardizovat. Díky tomu budete vědět, že u jedné značky pro vás bude vhodná velikost M, zatímco u jiné vám bude stačit S.',
    link: 'http://www.forbes.cz/aplikace-diky-ktere-si-pri-nakupu-obleceni-uz-nikdy-nespletete-velikost/',
    journal: 'Forbes, 24. ledna 2015',
  },
  {
    logo: beautyLifeLogo,
    id: 3,
    type: TYPE_BLOG,
    text: 'Je to výhra pro obě strany, jak pro nakupující, tak pro prodejce na internetu. Spokojení jsou zákazníci eshopů, protože nakupování je jednodušší a zboží jim lépe padne, stejně jako i provozovatelé internetových obchodů jsou nadšení, protože se spokojenějšími zákazníky odpadají náklady na řešení reklamací a výměny zboží. Velkou výhodou SizeID je také možnost sdílet nejvhodnější velikost oblečení se svými blízkými a tím se vyhnout nákupu nevhodného dárku.',
    link: 'http://beautylife-byaja.blogspot.cz/2014/12/jak-nakupovat-obleceni-na-internetu-bez.html',
    journal: 'Beauty Life by Aja, 15. prosince 2014',
  },
  {
    logo: petraLovelyHairLogo,
    id: 2,
    type: TYPE_BLOG,
    text: 'Naklikáte tam svoje míry a ono vám to řekne, jakou velikost koupit, což mi příjde docela praktický. Můžete to poslat i kamarádům a můžete si to nasdílet.',
    link: 'https://www.youtube.com/watch?v=RKVP8w8F1ZA&list=UUHREC4tSuCcapNv3gELUAHQ',
    journal: 'Petra Lovely Hair, 27. listopadu 2014',
    youtube:
      'https://www.youtube.com/embed/RKVP8w8F1ZA?list=UUHREC4tSuCcapNv3gELUAHQ',
  },
  {
    logo: CIANewsLogo,
    id: 1,
    type: TYPE_INTERNET,
    text: 'V systému složitých velikostních tabulek se téměř nedá vyznat a zboží většinou nepadne tak, jak má. Problémů si všimli absolventi ČVUT, kteří nyní přicházejí se službou SizeID. Ta je za pomoci standardizace velikostních tabulek schopná každému doporučit správnou velikost.',
    link: 'http://www.cianews.cz/cs/1118339-novy-cesky-startup-sizeid',
    journal: 'ČIANews, 20. listopadu 2014',
  },
];
